import { connect } from 'react-redux';
import { TripType } from '@eti/schema-types';
import { change } from 'redux-form';
import { css, mediaQueries } from '@eti/styles';
import AirportList from '../../common/availability-components/AirportList';
import { readMoreGrid } from '../../common/availability-components/styles';
import { ProductCardLayoutType } from '../../common/models/product';
import { getSelected } from '../../single-choice/utils/selection';
import { FAST_TRACK } from '../../products';
import { getUpsellProps, parseJsonProp } from '../../common/utils/productCardProps';
import ProductLayout from '../../common/main-layout/ProductLayout';
import AirportAvailability from '../../common/availability-components/AirportAvailability';
import { useProductData } from '../../common/hook/useProductData';
import NewSmallCardLayout from '../../common/components/small-card-layout/NewSmallCardLayout';
import { getAvailabilityList, getCartAvailability, validateAvailabilityTranslation } from './utils';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = FAST_TRACK;
const {
  Small: SMALL_CARD_LAYOUT,
  Main: MAIN_CARD_LAYOUT,
  PostBooking: POSTBOOKING_CARD_LAYOUT
} = ProductCardLayoutType;
const sharedTexts = {
  readMoreContent: 'fastTrackReadMoreModalContent',
  title: 'fastTrackTitle',
  airportAvailability: 'fasttrackGeneralPurpose'
};
const mainCardTranslations = {
  ...sharedTexts,
  abstractContent: 'fastTrackAbstract',
  upSell: 'fastTrackUpSellText'
};
const translations = {
  [MAIN_CARD_LAYOUT]: mainCardTranslations,
  [POSTBOOKING_CARD_LAYOUT]: mainCardTranslations,
  [SMALL_CARD_LAYOUT]: {
    ...sharedTexts,
    abstractContent: 'fastTrackAbstractSmallCard',
    upSell: 'fastTrackUpSellTextSmallCard'
  }
};
const productCardGrid = isSmallCardLayout => css`
  grid-area: 5 / ${isSmallCardLayout ? 1 : 2} / 6 / 3;
  ${isSmallCardLayout && 'margin-top: 8px;'}

  @media ${mediaQueries.medium.up} {
    margin-inline-start: ${isSmallCardLayout ? '0' : '16px'};
    ${isSmallCardLayout ? css`
          margin-top: 16px;
          max-width: 522px;
        ` : 'width: auto;'}
  }
`;
const availabilityWidgetWrapper = css`
  display: grid;
  grid-area: 5 / 2 / 6 / 3;
  justify-items: end;
`;
const FastTrack = _ref => {
  var _productSegmentAvaila;
  let {
    className,
    form,
    isSelected,
    order,
    productSpecificTexts,
    productPosition,
    dispatch,
    tripType,
    layoutType = MAIN_CARD_LAYOUT
  } = _ref;
  const texts = translations[layoutType] || {};
  const isMultiStop = tripType !== TripType.OneWay && tripType !== TripType.Return;
  const {
    rootElement,
    productData,
    translation: {
      airportAvailability,
      upSell
    },
    isSmallCardLayout
  } = useProductData({
    className,
    form,
    isSelected,
    layoutType,
    order,
    productId: PRODUCT_ID,
    productName: PRODUCT_NAME,
    productPosition,
    texts
  });
  if (!productData) {
    return null;
  }
  const availabilityList = getAvailabilityList(order.bounds, (_productSegmentAvaila = productSpecificTexts === null || productSpecificTexts === void 0 ? void 0 : productSpecificTexts.productSegmentAvailabilityTexts) !== null && _productSegmentAvaila !== void 0 ? _productSegmentAvaila : []);
  const availabilityProps = parseJsonProp(airportAvailability);
  const hasAllTranslation = validateAvailabilityTranslation(availabilityProps);
  const shouldDisplayAvailability = availabilityList && availabilityList.length > 0 && hasAllTranslation;
  const {
    upSellObject,
    isUpsellHighlight = false,
    shouldDisplayUpsell = false
  } = getUpsellProps(upSell, {
    shouldDisplayAvailability,
    availabilityList,
    tripType
  });
  const handleAvailabilitySelection = value => {
    if (!dispatch) {
      return;
    }
    if (value === 'true' && shouldDisplayAvailability) {
      var _order$travelers;
      dispatch(change(form, `${PRODUCT_NAME}.cartBreakDown`, getCartAvailability(order === null || order === void 0 || (_order$travelers = order.travelers) === null || _order$travelers === void 0 ? void 0 : _order$travelers.length, availabilityProps === null || availabilityProps === void 0 ? void 0 : availabilityProps.cart.purchasedMessage, availabilityList)));
    }
  };
  const updatedExtraProps = {
    ...(productData === null || productData === void 0 ? void 0 : productData.extraProps),
    availabilityList,
    availabilityTranslation: availabilityProps,
    onButtonChange: handleAvailabilitySelection,
    AirportListComponent: AirportList
  };
  const updatedProductData = {
    ...productData,
    extraProps: updatedExtraProps,
    upSell: upSellObject,
    isHighlighted: isUpsellHighlight,
    shouldDisplayUpsell
  };
  const AirportAvailabilityWidget = () => {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: isSelected && shouldDisplayAvailability && /*#__PURE__*/_jsx(AirportAvailability, {
        className: productCardGrid(isSmallCardLayout),
        isMultiStop: isMultiStop,
        isSelected: isSelected,
        testid: "availability-purchase"
      })
    });
  };
  switch (layoutType) {
    case SMALL_CARD_LAYOUT:
      return /*#__PURE__*/_jsxs(NewSmallCardLayout, {
        productData: updatedProductData,
        ref: rootElement,
        children: [shouldDisplayAvailability && /*#__PURE__*/_jsx(NewSmallCardLayout.ReadMore, {
          customGrid: readMoreGrid,
          children: /*#__PURE__*/_jsx(AirportAvailability, {
            isMultiStop: isMultiStop,
            testid: "availability-readmore"
          })
        }), /*#__PURE__*/_jsx("div", {
          className: availabilityWidgetWrapper,
          children: /*#__PURE__*/_jsx(AirportAvailabilityWidget, {})
        })]
      });
    case MAIN_CARD_LAYOUT:
    default:
      return /*#__PURE__*/_jsxs(ProductLayout, {
        productData: updatedProductData,
        ref: rootElement,
        children: [shouldDisplayAvailability && /*#__PURE__*/_jsx(ProductLayout.ReadMore, {
          customGrid: readMoreGrid,
          children: /*#__PURE__*/_jsx(AirportAvailability, {
            isMultiStop: isMultiStop,
            testid: "availability-readmore"
          })
        }), /*#__PURE__*/_jsx(AirportAvailabilityWidget, {})]
      });
  }
};
const mapStateToProps = (state, _ref2) => {
  let {
    form
  } = _ref2;
  return {
    isSelected: getSelected(FAST_TRACK.name, form)(state)
  };
};
export default connect(mapStateToProps)(FastTrack);
//# sourceMappingURL=FastTrack.js.map